module.exports = __webpack_public_path__ + "img/help_dataset_svg.5bce3bf7.png";